module.exports = __webpack_public_path__ + "static/media/PlankMale.7731bf76.svg";